import { all, call, put, takeEvery } from 'redux-saga/effects';

import { getUserData } from '../../services/api/auth';
import { getCsrfToken, retrieveUserFromSession } from '../auth/saga';
import { SYSTEM_ACTIONS, SYSTEM_TYPES } from './actions';

export function* watchSystem() {
  yield all([takeEvery(SYSTEM_TYPES.APP_STARTING, bootstrapApp)]);
  yield all([takeEvery(SYSTEM_TYPES.APP_STARTED, appStarted)]);
}

function* bootstrapApp() {
  yield call(getCsrfToken);
  yield call(retrieveUserFromSession);

  // done loading!
  yield put(SYSTEM_ACTIONS.appStarted());
}

function* appStarted() {
  // We'll load the using in bootstrapping (this way we show the loading spinner instead of flashing the login page)
  // yield call(retrieveUserFromSession);
}
